<template lang="pug">
AppModal(:value="value" @input="$emit('input', $event)" title="Subir registros de conductores")
  .import-modal-content
    p.mb-3
      | Sube un archivo Excel (.xlsx) con los conteos manuales por conductor y fecha para
      | cargar históricos faltantes o corregir cierres diarios incompletos.
    p.text-muted.small.mb-3
      | Columnas requeridas:
      code.mx-1 FECHA
      | ,
      code.mx-1 COD. CONDUCTOR
      | ,
      code.mx-1 CONDUCTOR
      | ,
      code.mx-1 EN TRÁNSITO
      | ,
      code.mx-1 APROBADOS
      | ,
      code.mx-1 PARCIALES
      | ,
      code.mx-1 RECHAZADOS
      | ,
      code.mx-1 CANCELADOS
      | ,
      code.mx-1 TOTAL
      | (opcional).

    b-form-file(
      v-model="file"
      placeholder="Elige un archivo o arrástralo aquí..."
      drop-placeholder="Suelta el archivo aquí..."
      accept=".xlsx"
      class="mb-3"
    )

    .alert.alert-danger(v-if="errorMsg") {{ errorMsg }}
    .alert.alert-success(v-if="successMsg") {{ successMsg }}

    .errors-container.mt-2(v-if="errors.length" style="max-height: 250px; overflow-y: auto; border: 1px solid #f5c6cb; border-radius: 4px; padding: 10px; background-color: #f8d7da;")
      ul.text-danger.mb-0.pl-3
        li(v-for="(err, idx) in errors" :key="idx" style="font-size: 0.9rem;") {{ err }}

  template(#footer)
    AppButton(outline @click="close" class="mr-2") Cancelar
    AppButton(:disabled="!file || loading" @click="handleImport")
      span(v-if="loading") Importando...
      span(v-else) Importar
</template>

<script>
import AppModal from '@/components/UI/AppModal.vue'
import AppButton from '@/components/UI/AppButton.vue'
import { mapActions } from 'vuex'

export default {
  name: 'ModalImportDriverCounts',
  components: { AppModal, AppButton },
  props: {
    value: { type: Boolean, default: false }
  },
  data() {
    return {
      file: null,
      loading: false,
      errorMsg: '',
      successMsg: '',
      errors: []
    }
  },
  watch: {
    value(isOpen) {
      if (isOpen) this.reset()
    }
  },
  methods: {
    ...mapActions('settlement', ['importDriverCountsExcel']),
    reset() {
      this.file = null
      this.loading = false
      this.errorMsg = ''
      this.successMsg = ''
      this.errors = []
    },
    close() {
      this.$emit('input', false)
    },
    async handleImport() {
      if (!this.file) return
      this.loading = true
      this.errorMsg = ''
      this.successMsg = ''
      this.errors = []

      const formData = new FormData()
      formData.append('file', this.file)

      try {
        const response = await this.importDriverCountsExcel({ data: formData })
        if (response && response.status === 200 && response.data?.success) {
          this.successMsg = `Importación completada. Se procesaron ${response.data.processedRows} filas.`
          this.$emit('success')
          setTimeout(() => this.close(), 2000)
        } else {
          const data = response?.data
          if (data?.errors?.length) {
            this.errors = data.errors
            this.errorMsg = 'No se pudo importar el archivo:'
          } else {
            this.errorMsg = data?.message || 'Error en el procesamiento del archivo.'
          }
        }
      } catch (err) {
        this.errorMsg = err?.response?.data?.message || 'Error al subir el archivo.'
      } finally {
        this.loading = false
      }
    }
  }
}
</script>